import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=fafb5fda&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fafb5fda')) {
      api.createRecord('fafb5fda', component.options)
    } else {
      api.reload('fafb5fda', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=fafb5fda&", function () {
      api.rerender('fafb5fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2T2IinIkhZz1y/JS/offershelp.vue"
export default component.exports